import { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { DataProvider } from '../../../store/ContextProvider'
import Loading from '../../Loading'

function ViewUser() {
    const { BeURL, showAlert } = useContext(DataProvider)
    const { id } = useParams()
    const [user, setUser] = useState(null)
    const [page, setPage] = useState(1)
    const itemsPerPage = 5

    useEffect(() => {
        if (BeURL && id) {
            fetch(`${BeURL}/fetch-user/${id}`, { credentials: 'include' })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        setUser(data.user)
                    } else {
                        showAlert(data.message)
                    }
                })
                .catch(err => {
                    console.log('Error in fetching Users:', err)
                    showAlert('Trouble in connecting to the Server, Try again later.')
                })
        }
    }, [BeURL, id])

    if (!BeURL || !id || !user) return <Loading/>

    // Remove unwanted fields
    const { _id, profileViews, resumeDownloads, resumeViews, ...userData } = user

    // Calculate overall counts (based on history length)
    const profileViewCount = userData?.profileViewHistory?.length || 0
    const resumeViewCount = userData?.resumeViewHistory?.length || 0
    const resumeDownloadCount = userData?.resumeDownloadHistory?.length || 0

    // Pagination for arrays
    const paginate = (arr) => {
        if (!arr) return []
        const start = (page - 1) * itemsPerPage
        return arr.slice(start, start + itemsPerPage)
    }

    console.log("user data",userData)

    return (
        <div className="p-6 bg-white shadow rounded-2xl min-h-[75vh] mb-10 mt-10">
            <h2 className="text-2xl font-bold text-primary-500 my-4">User Details</h2>
            {/* General Info */}
            <div className="grid grid-cols-2 gap-4 text-sm">
                <div><span className="font-semibold">ID:</span> {userData?.id || "-"}</div>
                <div><span className="font-semibold">Name:</span> {userData?.fullName || "-"}</div>
                <div><span className="font-semibold">Email:</span> {userData?.email || "-"}</div>
                <div><span className="font-semibold">Contact:</span> {userData?.contact || "-"}</div>
                <div><span className="font-semibold">Role:</span> {userData?.role || "-"}</div>
            </div>
            {userData.role === 'employer' && (
                <>
                    {/* Stats */}
                    <div className="mt-6 flex flex-wrap justify-center items-stretch gap-4">
                        <div className="bg-blue-100 flex-1 p-4 rounded-xl shadow">
                            <p className="text-2xl font-bold text-primary-500">{profileViewCount}</p>
                            <p className="text-sm text-gray-700">Total Profile Views</p>
                        </div>
                        <div className="bg-purple-100 flex-1 p-4 rounded-xl shadow">
                            <p className="text-2xl font-bold text-primary-500">{resumeViewCount}</p>
                            <p className="text-sm text-gray-700">Total Resume Views</p>
                        </div>
                        <div className="bg-green-100 flex-1 p-4 rounded-xl shadow">
                            <p className="text-2xl font-bold text-primary-500">{resumeDownloadCount}</p>
                            <p className="text-sm text-gray-700">Total Resume Downloads</p>
                        </div>
                    </div>

                    {/* Device Infos */}
                    <div className="mt-8 overflow-auto">
                        <h3 className="text-xl font-semibold text-secondary-500 mb-2">Recent Log Infos</h3>
                        <table className="w-full text-sm border">
                            <thead className="bg-primary-500 text-white text-left">
                                <tr>
                                    <th className="p-2">Browser</th>
                                    <th className="p-2">Recent Log time</th>
                                    {/* <th className="p-2">Fingerprint</th> */}
                                    <th className="p-2">Recent Logins</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginate(userData.deviceInfos).reverse().map((d, i) => (
                                    <tr key={i} className="odd:bg-gray-50">
                                        <td className="p-2">{d.browserName}</td>
                                        <td className="p-2">{d.recentLoggedTime.length ? new Date(d.recentLoggedTime[d.recentLoggedTime.length-1]).toLocaleString("en-GB") : "-"}</td>
                                        {/* <td className="p-2">{d.fingerPrintId}</td> */}
                                        <td className="p-2">{d.recentLoggedTime?.length || 0}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {userData.deviceInfos?.length > itemsPerPage && (
                            <div className="my-2 flex justify-end gap-2">
                                <button
                                    onClick={() => setPage(p => Math.max(p - 1, 1))}
                                    className="px-3 py-1 bg-slate-100 rounded text-slate-700 font-medium hover:bg-slate-300"
                                >
                                    Prev
                                </button>
                                <button
                                    onClick={() => setPage(p => p + 1)}
                                    className="px-3 py-1 bg-slate-100 rounded text-slate-700 font-medium hover:bg-slate-300"
                                >
                                    Next
                                </button>
                            </div>
                        )}
                    </div>

                    {/* Histories */}
                    <div className="mt-8">
                        <h3 className="text-xl font-semibold text-secondary-500 mb-2">Activity History</h3>
                        <div className="grid grid-cols-3 gap-4">
                            <div className="p-3 border rounded-xl">
                                <p className="font-semibold">Profile View History</p>
                                <div className='my-3 overflow-y-auto max-h-[300px]'>
                                    {userData.profileViewHistory?.map((h, idx) => (
                                        <p key={idx} className="text-xs text-gray-600 cursor-pointer hover:text-primary-200" onClick={()=>window.open(`/candidate/${h.candidateId}`, "_blank")}>Candidate: {h.candidateId}</p>
                                    ))}
                                </div>
                            </div>
                            <div className="p-3 border rounded-xl">
                                <p className="font-semibold">Resume View History</p>
                                <div className='my-3 overflow-y-auto max-h-[300px]'>
                                    {userData.resumeViewHistory?.map((h, idx) => (
                                        <p key={idx} className="text-xs text-gray-600 cursor-pointer hover:text-primary-200" onClick={()=>window.open(`/candidate/${h.candidateId}`, "_blank")}>Candidate: {h.candidateId}</p>
                                    ))}
                                </div>
                            </div>
                            <div className="p-3 border rounded-xl">
                                <p className="font-semibold">Resume Download History</p>
                                <div className='my-3 overflow-y-auto max-h-[300px]'>
                                    {userData.resumeDownloadHistory?.map((h, idx) => (
                                        <p key={idx} className="text-xs text-gray-600 cursor-pointer hover:text-primary-200" onClick={()=>window.open(`/candidate/${h.candidateId}`, "_blank")}>Candidate: {h.candidateId}</p>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}

export default ViewUser



